import React from "react";

import { SettingsConfirmModal } from "../../../../../components/modal/SettingsConfirmModal";
import { WarningExclaimSvg } from "../../../../../components/svg/WarningExclaimSvg";
import { TaskTemplateConfirmModalsProps } from "../model/taskTemplateEditor.types";
import { TemplateDeleteConfirm } from "./TemplateDeleteConfirm";

export const TaskTemplateConfirmModals: React.FC<
  TaskTemplateConfirmModalsProps
> = ({
  template,
  isDeleteOpen,
  isDeactivateOpen,
  isActivateOpen,
  isDeleting,
  isDeactivating,
  isActivating,
  onCloseDelete,
  onCloseDeactivate,
  onCloseActivate,
  onConfirmDelete,
  onConfirmDeactivate,
  onConfirmActivate,
}) => (
  <>
    {isDeleteOpen && template && (
      <TemplateDeleteConfirm
        templateId={template.id}
        templateName={template.templateName}
        isDeleting={isDeleting}
        onClose={onCloseDelete}
        onConfirm={onConfirmDelete}
      />
    )}

    {isDeactivateOpen && template && (
      <SettingsConfirmModal
        onClose={onCloseDeactivate}
        onConfirm={onConfirmDeactivate}
        isLoading={isDeactivating}
        icon={<WarningExclaimSvg sizeCx={"h-6 w-6"} />}
        title={`Deactivate ‘${template.templateName}’ template?`}
        description={
          "Are you sure you want to deactivate this template? You can reactivate it at any time."
        }
        confirmText={"Deactivate"}
        variant={"warning"}
      />
    )}

    {isActivateOpen && template && (
      <SettingsConfirmModal
        onClose={onCloseActivate}
        onConfirm={onConfirmActivate}
        isLoading={isActivating}
        icon={<WarningExclaimSvg sizeCx={"h-6 w-6"} />}
        title={`Activate ‘${template.templateName}’ template?`}
        description={
          "Are you sure you want to activate this template? You can deactivate it at any time."
        }
        confirmText={"Activate"}
        variant={"warning"}
      />
    )}
  </>
);
